import { render, staticRenderFns } from "./result2.vue?vue&type=template&id=15d409f3&scoped=true&"
import script from "./result2.vue?vue&type=script&lang=js&"
export * from "./result2.vue?vue&type=script&lang=js&"
import style0 from "./result2.vue?vue&type=style&index=0&id=15d409f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d409f3",
  null
  
)

export default component.exports